import { render, staticRenderFns } from "./HotpotOpenTablePage.vue?vue&type=template&id=52e3e2e8&scoped=true"
import script from "./HotpotOpenTablePage.vue?vue&type=script&lang=js"
export * from "./HotpotOpenTablePage.vue?vue&type=script&lang=js"
import style0 from "./HotpotOpenTablePage.vue?vue&type=style&index=0&id=52e3e2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e3e2e8",
  null
  
)

export default component.exports